const { atom } = require("jotai");

export const allTableRecordsAtom = atom([]);

export const totalRecordsAtom = atom(0);

export const searchQueryAtom = atom("");

export const phoneSearchAtom = atom("");

export const orderIdSearchAtom = atom("");

export const dateSortingAtom = atom(true);

export const pickUpDateAtom = atom(null);

export const dropOffDateAtom = atom(null);
